// types
import type { ProductComparisonProps } from './types';

// components
import { Title } from '../Title/Title';
import { ResponsiveTable } from 'components/ResponsiveSlideTable/ResponsiveTable';

// utils
import { TitleFormats } from '../Title/title.types';
import { useSectionId } from 'utils/hooks/use-section-id';
import { useColNumber } from './hooks';

export function ProductComparison({
  title,
  subtitle,
  anchor,
  titleInAnchor,
  productItems,
  groupItems,
  grayTable,
  contentIndex,
  isSectionReference,
}: Readonly<ProductComparisonProps>) {
  const sectionId = useSectionId(title, anchor, titleInAnchor, contentIndex);
  const colNumber = useColNumber();

  return (
    <div className="grid-container" id={sectionId}>
      <Title
        title={title}
        subtitle={subtitle}
        Format={TitleFormats.h2}
        titlePreviewId="#st_title"
        subtitlePreviewId="#st_subtitle"
        isSectionReference={isSectionReference}
        formatClassName="h3"
      />
      <ResponsiveTable
        productItems={productItems}
        groupItems={groupItems}
        grayTable={grayTable}
        numberOfVisibleCols={colNumber}
        isComparison
      />
    </div>
  );
}
